var map = {
	"./data_ar.json": [
		8472,
		472
	],
	"./data_en.json": [
		5264,
		264
	],
	"./data_es.json": [
		7479,
		479
	],
	"./data_no.json": [
		5228,
		228
	],
	"./data_ru.json": [
		1322,
		322
	],
	"./data_uk.json": [
		655,
		655
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 418;
module.exports = webpackAsyncContext;